import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { LoginLoadComponent } from '../login-load/login-load.component';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-redirection',
  standalone: true,
  imports: [LoginLoadComponent],
  templateUrl: './redirection.component.html',
  styleUrl: './redirection.component.scss',
})
export class RedirectionComponent {
  constructor(
    private router: Router,
    private _auth: AuthService,
    private _messageService: MessageService
  ) {
    // let tk = this.activatedRoute.snapshot.queryParamMap.get('tk');
    let tk = this.getCookie('tk');
    if (!tk) {
      this.router.navigate(['/login']);
    } else {
      let params = {
        tk: tk,
      };
      this._auth.getJwtToken(params).subscribe({
        next: (res: any) => {
          if (res.token) {
            this._auth.isLoggingIn = true;
            setTimeout(() => {
              this._auth.setJwtTokenAndRedirect(res.token);
              // Check for stored returnUrl from SSO login
              const storedReturnUrl = sessionStorage.getItem('sso_returnUrl');
              if (storedReturnUrl) {
                sessionStorage.removeItem('sso_returnUrl');
                this.router.navigateByUrl(storedReturnUrl);
              } else {
                this.router.navigate(['/']);
              }
            }, 300);
            this.deleteCookie('tk');
          } else {
            this.router.navigate(['/login']);
          }
        },
        error: (err) => {
          this.router.navigate(['/login']);
          this._messageService.add({
            severity: 'error',
            summary: 'Access Denied',
            detail: err.error.message || 'Internal Server Error',
            key: 'tr',
          });
        },
      });
    }
  }

  private getCookie(name: string): string | null {
    const match = document.cookie.match(
      new RegExp('(^| )' + name + '=([^;]+)')
    );
    return match ? match[2] : null;
  }

  private deleteCookie(name: string): void {
    document.cookie =
      name + '=; expires=Thu, 01 Jan 0000 00:00:00 UTC; path=/;';
  }
}
